import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createApprovalCode,
  deleteApprovalCode,
  getApprovalCode,
  getApprovalCodes,
  getApprovalCodesMasterData,
  updateApprovalCode
} from '../../../api/approval-codes';
import { ApprovalType } from '../ApprovalType/approvalTypeSlice';

export const getApprovalCodesAsync = createAsyncThunk(
  'approvalCodes/getApprovalCodes',
  getApprovalCodes
);

export const getApprovalCodesMasterDataAsync = createAsyncThunk(
  'approvalCodes/getApprovalCodesMasterData',
  getApprovalCodesMasterData
);

export const getApprovalCodeAsync = createAsyncThunk(
  'approvalCodes/getApprovalCode',
  getApprovalCode
);

export const createApprovalCodeAsync = createAsyncThunk(
  'approvalCodes/createApprovalCode',
  createApprovalCode
);

export const updateApprovalCodeAsync = createAsyncThunk(
  'approvalCodes/updateApprovalCode',
  updateApprovalCode
);

export const deleteApprovalCodeAsync = createAsyncThunk(
  'approvalCodes/deleteApprovalCode',
  deleteApprovalCode
);

export interface ApprovalCode {
  id: number;
  name: string;
  approvalTypes: ApprovalType[];
}

interface ApprovalCodeState {
  data: ApprovalCode[];
  masterData: ApprovalCode[];
  count: number;
  selectedApprovalCode: ApprovalCode | null;
}

const initialState: ApprovalCodeState = {
  data: [],
  masterData: [],
  count: 0,
  selectedApprovalCode: null
};

export default createSlice({
  name: 'approvalCodes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getApprovalCodesAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(
      getApprovalCodesMasterDataAsync.fulfilled,
      (state, action) => {
        state.masterData = action.payload.data;
        state.count = action.payload.count;
      }
    );
    builder.addCase(getApprovalCodeAsync.fulfilled, (state, action) => {
      state.selectedApprovalCode = action.payload;
    });
  }
});
